import { render, staticRenderFns } from "./crateStock.vue?vue&type=template&id=308d75df"
import script from "./crateStock.vue?vue&type=script&lang=js"
export * from "./crateStock.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/vsts/work/1/s/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('308d75df')) {
      api.createRecord('308d75df', component.options)
    } else {
      api.reload('308d75df', component.options)
    }
    module.hot.accept("./crateStock.vue?vue&type=template&id=308d75df", function () {
      api.rerender('308d75df', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/Production/crateStock.vue"
export default component.exports